import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS = {
	year: 'year',
	dayOf: 'day of',
	datedThe: 'DATED the',
};
export interface RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS {
	datedThe: string;
	dayOf: string;
	year: string;
}
